
import { defineComponent } from "vue";

import MyGroupsContent from "./components/MyGroupsContent.vue";

export default defineComponent({
  name: "MyGroupsContentPage",
  components: {
    MyGroupsContent
  },
});
